import React from "react";
import { createRoot } from "react-dom/client";
import { HashRouter as Router, Route, Routes } from "react-router-dom";

import AuthContextProvider, { AuthContext } from "./context/AuthContext";

import Login from "./components/Auth/Login/Login";
import PrivateRoute from "./components/PrivateRoute";
import AdminRoute from "./components/AdminRoute";
import InitDoctorFlow from "./components/Doctor/InitDoctorFlow/InitDoctorFlow";
import CreatePatient from "./components/Patients/CreatePatient/CreatePatient";
import MainDoctor from "./components/Doctor/MainDoctor/MainDoctor";
import PatientInfo from "./components/Patients/PatientInfo/PatientInfo";
import Results from "./components/Questionaries/Results/Results";
import PatientInfoQuestionary from "./components/Questionaries/PatientInfoQuestionary/PatientInfoQuestionary";
import PatientsAgreement from "./components/Patients/PatientsAgreement/PatientsAgreement";
import AdverseReactions from "./components/Patients/AdverseReactions/AdverseReactions";
import Abandon from "./components/Patients/Abandon/Abandon";
import TechnicalSupport from "./components/Doctor/TechnicalSupport/TechnicalSupport";
import Agreement from "./components/Agreement";
import MainAdmin from "./components/Admin/MainAdmin/MainAdmin";
import DoctorInfo from "./components/Admin/DoctorInfo/DoctorInfo";
import AdminPatientsList from "./components/Admin/AdminPatientList/AdminPatientList";
import AdminPatientInfo from "./components/Admin/AdminPatientInfo/AdminPatientInfo";
import CreateDoctor from "./components/Admin/CreateDoctor/CreateDoctor";
import DownloadConsentment from "./components/Patients/DownloadConsentment/DownloadConsentment";
import "./App.css";

function Navigation() {
  return (
    <Router>
      <Routes>
        <Route
          path="/downloadconsentment/:doctorId/:patientId"
          element={<DownloadConsentment />}
        ></Route>
        <Route path="/agreement" element={<Agreement />} />
        <Route
          path="/init"
          element={
            <PrivateRoute>
              <InitDoctorFlow />
            </PrivateRoute>
          }
        ></Route>
        <Route
          path="/initAdmin"
          element={
            <AdminRoute>
              <MainAdmin />
            </AdminRoute>
          }
        ></Route>
        <Route
          path="/doctorInfo"
          element={
            <AdminRoute>
              <DoctorInfo />
            </AdminRoute>
          }
        ></Route>
        <Route
          path="/adminPatientsList"
          element={
            <AdminRoute>
              <AdminPatientsList />
            </AdminRoute>
          }
        ></Route>
        <Route
          path="/adminPatientInfo"
          element={
            <AdminRoute>
              <AdminPatientInfo />
            </AdminRoute>
          }
        ></Route>
        <Route
          path="/createDoctor"
          element={
            <AdminRoute>
              <CreateDoctor />
            </AdminRoute>
          }
        ></Route>
        <Route
          path="/mainDoctor"
          element={
            <PrivateRoute>
              <MainDoctor />
            </PrivateRoute>
          }
        ></Route>
        <Route
          path="/createPatient"
          element={
            <PrivateRoute>
              <CreatePatient />
            </PrivateRoute>
          }
        ></Route>
        <Route
          path="/patientInfo"
          element={
            <PrivateRoute>
              <PatientInfo />
            </PrivateRoute>
          }
        ></Route>
        <Route
          path="/ci"
          element={
            <PrivateRoute>
              <PatientsAgreement />
            </PrivateRoute>
          }
        ></Route>
        <Route
          path="/showResults"
          element={
            <PrivateRoute>
              <Results />
            </PrivateRoute>
          }
        ></Route>
        <Route
          path="/showQuestionary"
          element={
            <PrivateRoute>
              <PatientInfoQuestionary />
            </PrivateRoute>
          }
        ></Route>
        <Route
          path="/adverseReactions"
          element={
            <PrivateRoute>
              <AdverseReactions />
            </PrivateRoute>
          }
        ></Route>
        <Route
          path="/abandon"
          element={
            <PrivateRoute>
              <Abandon />
            </PrivateRoute>
          }
        ></Route>
        <Route
          path="/technical"
          element={
            <PrivateRoute>
              <TechnicalSupport />
            </PrivateRoute>
          }
        ></Route>
        <Route path="/" Component={Login} />
        <Route path="/login" Component={Login} />
      </Routes>
    </Router>
  );
}

function Root() {
  return <Navigation />;
}

function App() {
  return (
    <AuthContextProvider>
      <Root />
    </AuthContextProvider>
  );
}

export default App;
